import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { UsuarioComisionFreelanceTarifa } from '../_models/usuario-comision-freelance-tarifa';

@Injectable({
  providedIn: 'root'
})
export class UsuarioComisionFreelanceTarifaService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/usuariosComisionesFreelanceTarifas';

  constructor( private httpClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httpClient.get( this.rutServicio ).pipe( map( res => res as UsuarioComisionFreelanceTarifa[] ) );
  }

  listadoHabilitados() {
    return this.httpClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as UsuarioComisionFreelanceTarifa[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httpClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as UsuarioComisionFreelanceTarifa ) );
  }

  listadoPorUsuarioFreelance( id: string ) {
    return this.httpClient.get( this.rutServicio + '/usuarioComision/' + id + '/enabled' ).pipe( map( res => res as UsuarioComisionFreelanceTarifa[] ) );
  }

  crear( regCrear: UsuarioComisionFreelanceTarifa ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as UsuarioComisionFreelanceTarifa ) );
  }

  actualizar( regActualizar: UsuarioComisionFreelanceTarifa ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

}
